import React, {Component} from 'react';
import DocumentsPartial from '../patientPartials/DocumentsPartial';

class Documents extends Component {
  render() {
    return(
        <DocumentsPartial patientId={this.props.patientId}/>
    );
  }
}

export default Documents;
